<template>
  <v-card>
    <popup-form
      :title="isNew ? 'New User' : 'Update User'"
      :isNew="isNew"
      deleteItem="user"
      :buttonTitle="tab == 2 ? (isNew ? 'Create' : 'Update') : 'Next'"
      :canDelete="canDelete"
      v-on:close="close"
      v-on:submit="submit"
      v-on:remove="remove"
    >
      <v-stepper v-model="tab" class="elevation-0">
        <v-stepper-header class="elevation-2">
          <v-stepper-step :complete="tab > 1" step="1" editable>
            User
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="tab > 2" step="2" editable>
            Permissions
          </v-stepper-step>
        </v-stepper-header>
        <v-row justify="center" no-gutters class="pt-1">
          <v-btn-toggle
            v-if="user.role != 'owner'"
            v-model="user.role"
            tiles
            color="secondary"
            group
            :style="!isAdmin ? 'pointer-events: none' : ''"
          >
            <v-btn value="user"> User </v-btn>
            <v-btn value="admin"> ADMIN </v-btn>
          </v-btn-toggle>
          <div v-else>
            <h1>Owner</h1>
          </div>
        </v-row>
        <v-divider></v-divider>
        <v-stepper-items>
          <v-stepper-content step="1" class="pa-0">
            <v-form ref="userForm" lazy-validation>
              <v-container>
                <v-row class="grey lighten-5 px-4" no-gutters>
                  <v-col cols="12">
                    <v-text-field
                      v-model="user.name"
                      label="Full Name"
                      filled
                      outlined
                      :rules="[rules.required, rules.name]"
                      autocomplete="new"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      v-model="user.email"
                      label="Email"
                      filled
                      outlined
                      :rules="[rules.email]"
                      autocomplete="new"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" v-if="isNew || isCurrentUser">
                    <v-text-field
                      v-model="user.password"
                      label="Password"
                      filled
                      required
                      outlined
                      :rules="[rules.required, rules.password]"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" v-if="isNew || isCurrentUser">
                    <v-text-field
                      v-model="user.confirmPassword"
                      label="Confirm Password"
                      filled
                      outlined
                      required
                      :rules="[
                        rules.required,
                        rules.confirmPassword(user.password),
                      ]"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-stepper-content>

          <v-stepper-content step="2" class="pa-0">
            <v-form ref="permissionsForm" lazy-validation>
              <v-container>
                <v-row class="grey lighten-5 px-4" no-gutters>
                  <v-col
                    cols="12"
                    v-for="role in user.roles"
                    :key="role.location"
                    class="mb-10"
                  >
                    <div>
                      <span class="font-weight-bold">{{ role.name }} </span>

                      <p>{{ role.address }}</p>
                      <v-checkbox
                        v-model="user.defaultLocation"
                        :value="role.location"
                        label="Default"
                        hide-details
                        dense
                        class="pa-0 ma-0"
                      ></v-checkbox>
                    </div>
                    <v-radio-group
                      v-for="(p, index) in role.permissions"
                      :key="index"
                      v-model="p.permission"
                      row
                      dense
                      hide-details
                      :label="p.name"
                      :disabled="disabledPermissions"
                    >
                      <v-spacer></v-spacer>
                      <v-radio label="None" :value="0"></v-radio>
                      <v-radio label="Read-Only" :value="1"></v-radio>
                      <v-radio label="Read-Write" :value="2"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </popup-form>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import rules from "@/rules.js";

export default {
  props: {
    user: Object,
    locations: Array,
    canDelete: Boolean,
    isAdmin: Boolean,
  },
  data() {
    return {
      rules: rules,
      tab: 1,
      permissions: [
        "Planner",
        "Candidates",
        "Clients",
        "Timesheets",
        "Invoices",
        "Analytics",
      ],
    };
  },
  watch: {
    "user.role": function (val) {
      this.setPermisisons();
    },
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
    disabledPermissions() {
      return !this.isAdmin || this.user.role != "user";
    },
    isNew() {
      return !this.user._id;
    },
    isCurrentUser() {
      return this.account.user._id == this.user._id;
    },
    payload() {
      var user = {
        ...this.user,
      };
      if (user.role != "user") {
        user.roles = null;
      }
      return user;
    },
  },

  methods: {
    ...mapActions({
      createUser: "account/createUser",
      updateUser: "account/updateUser",
      deleteUser: "account/deleteUser",
    }),
    submit() {
      if (this.tab == 1) {
        if (this.$refs.userForm.validate()) {
          this.tab = 2;
        }
      } else {
        console.log(this.payload);
        this.isNew ? this.create() : this.update();
      }
    },
    async create() {
      await this.createUser(this.payload);
      this.close();
    },
    async update() {
      await this.updateUser(this.payload);
      this.close();
    },

    async remove() {
      await this.deleteUser(this.user._id);
      this.close();
    },
    close() {
      this.$emit("close");
    },

    setPermisisons() {
      this.user.roles = this.locations
        .filter((l) => {
          return l.name != "Demo";
        })
        .map((l) => {
          return {
            location: l._id,
            name: l.name,
            address: `${l.address}, ${l.city}, ${l.postcode}`,
            permissions: this.permissions.map((p) => {
              return {
                name: p,
                permission: this.user.role == "user" ? 0 : 2,
              };
            }),
          };
        });
    },
  },

  mounted() {
    if (!this.user.roles || this.user.roles.length == 0) {
      this.setPermisisons();
    } else {
      this.user.roles = this.user.roles.map((r) => {
        var location = this.locations.find((l) => {
          return l._id == r.location;
        });
        return {
          location: location._id,
          name: location.name,
          address: `${location.address}, ${location.city}, ${location.postcode}`,
          permissions: r.permissions.map((p) => {
            return {
              name: p.name,
              permission: p.permission,
            };
          }),
        };
      });
    }
  },
};
</script>
